import MetrologyPage from './components/MetrologyPage';
import MetrologyMaster from './components/MetrologyMaster';

const routes = [
  {
    path: '/metrology',
    name: 'menu.metrology',
    className: 'menu-metrology',
    icon: 'metrology',
    customIcon: true,
    loginRequired: true,
    component: MetrologyPage,
    weight: 1,
    permission: ['metrology'],
    children: [],
  },
  {
    path: '/metrology-master',
    name: 'menu.metrology',
    className: 'menu-metrology',
    icon: 'metrology',
    customIcon: true,
    loginRequired: true,
    hideOnMenu: true,
    component: MetrologyMaster,
    weight: 1,
    permission: ['metrology'],
    children: [],
  },
];

export default routes;
